var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('b-container',{attrs:{"fluid":"sm"}},[_c('b-row',{staticClass:"justify-content-center vh-100",attrs:{"align-v":"center"}},[_c('b-col',{staticClass:"box-login",attrs:{"cols":"12","md":"6","lg":"4"}},[_c('login-options')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }